import { useFormikContext } from 'formik';
import { useCallback } from 'react';
import { useRegisterReportFormApply } from './useRegisterReportFormApply';

/**
 * Exposes Formik set-field + submit to report context so table filters can update the form.
 */
export function RegisterFormikFormApply() {
  const { setFieldValue, submitForm } = useFormikContext();

  const apply = useCallback(
    async (field: string, value: unknown) => {
      await setFieldValue(field, value, false);
      await submitForm();
    },
    [setFieldValue, submitForm],
  );

  useRegisterReportFormApply(apply);

  return null;
}
